import React from 'react';
import { useTranslation } from 'react-i18next';
import * as Icons from 'lucide-react';
import ContactForm from '../components/ContactForm';

const DrKumarProfilePage = () => {
  const { t } = useTranslation();

  const skillKeys = ['skill1', 'skill2', 'skill3', 'skill4', 'skill5', 'skill6'];

  const educationKeys = [
    { degreeKey: 'phd', fieldKey: 'phdField' },
    { degreeKey: 'masters', fieldKey: 'mastersField' },
    { degreeKey: 'bams', fieldKey: 'bamsField' },
    { degreeKey: 'nd', fieldKey: 'ndField' },
    { degreeKey: 'dyt', fieldKey: 'dytField' }
  ];

  return (
    <div style={{ background: '#111827', paddingTop: '80px' }}>
      {/* Hero Section */}
      <section
        style={{
          background: '#1a2744',
          padding: '5rem 1.2rem',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {/* Background Effects */}
        <div
          style={{
            position: 'absolute',
            top: '10%',
            left: '5%',
            width: '400px',
            height: '400px',
            background: 'radial-gradient(circle, rgba(34, 197, 94, 0.15) 0%, transparent 70%)',
            borderRadius: '50%',
            filter: 'blur(60px)',
            zIndex: 0,
          }}
        />
        <div
          style={{
            position: 'absolute',
            bottom: '10%',
            right: '10%',
            width: '300px',
            height: '300px',
            background: 'radial-gradient(circle, rgba(245, 158, 11, 0.15) 0%, transparent 70%)',
            borderRadius: '50%',
            filter: 'blur(60px)',
            zIndex: 0,
          }}
        />

        <div className="container" style={{ position: 'relative', zIndex: 2 }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '3rem', alignItems: 'center' }}>
            {/* Profile Image */}
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <div
                style={{
                  width: '300px',
                  height: '300px',
                  borderRadius: '50%',
                  overflow: 'hidden',
                  border: '4px solid rgba(34, 197, 94, 0.5)',
                  boxShadow: '0 0 40px rgba(34, 197, 94, 0.3)',
                }}
              >
                <img 
                  src="https://customer-assets.emergentagent.com/job_ayurtech-hub/artifacts/ghy8guf3_Dr%20Kumar.jpg"
                  alt="Dr. K. Kumar"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              </div>
            </div>

            {/* Profile Info */}
            <div>
              <div
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  background: 'rgba(34, 197, 94, 0.2)',
                  borderRadius: '2rem',
                  padding: '0.5rem 1rem',
                  marginBottom: '1.5rem',
                  border: '1px solid rgba(34, 197, 94, 0.4)',
                }}
              >
                <Icons.Award size={16} color="#22c55e" />
                <span style={{ color: '#22c55e', fontWeight: '600', fontSize: '0.85rem' }}>
                  {t('drKumar.badge')}
                </span>
              </div>

              <h1 className="heading-hero" style={{ marginBottom: '1rem', color: 'var(--text-light)' }}>
                {t('drKumar.name')}
              </h1>
              <p className="heading-3" style={{ color: '#22c55e', marginBottom: '1.5rem' }}>
                {t('drKumar.fullName')}
              </p>
              <p className="body-large" style={{ color: 'rgba(255, 255, 255, 0.8)', lineHeight: '1.8', marginBottom: '2rem' }}>
                {t('drKumar.description')}
              </p>

              {/* Contact Info */}
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1.5rem' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <Icons.Phone size={18} color="#22c55e" />
                  <span style={{ color: 'rgba(255, 255, 255, 0.8)' }}>+91-9958096324</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <Icons.Mail size={18} color="#22c55e" />
                  <span style={{ color: 'rgba(255, 255, 255, 0.8)' }}>drkkumar1508@gmail.com</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <Icons.Globe size={18} color="#22c55e" />
                  <a href="https://www.drkumarslifestyle.com" target="_blank" rel="noopener noreferrer" style={{ color: '#22c55e' }}>
                    www.drkumarslifestyle.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Skills & Expertise */}
      <section style={{ padding: '5rem 1.2rem', background: '#1f2937' }}>
        <div className="container">
          <h2 className="heading-1" style={{ textAlign: 'center', marginBottom: '3rem' }}>
            {t('drKumar.skillsTitle')}
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem' }}>
            {skillKeys.map((skillKey, index) => (
              <div
                key={index}
                style={{
                  background: 'rgba(34, 197, 94, 0.1)',
                  borderRadius: '1rem',
                  padding: '1.5rem',
                  border: '1px solid rgba(34, 197, 94, 0.3)',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem',
                }}
              >
                <Icons.CheckCircle size={24} color="#22c55e" style={{ flexShrink: 0, marginTop: '2px' }} />
                <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>{t(`drKumar.${skillKey}`)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Education */}
      <section style={{ padding: '5rem 1.2rem', background: '#111827' }}>
        <div className="container">
          <h2 className="heading-1" style={{ textAlign: 'center', marginBottom: '3rem' }}>
            {t('drKumar.educationTitle')}
          </h2>
          <div style={{ 
            display: 'flex', 
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: '1.5rem', 
            maxWidth: '1200px', 
            margin: '0 auto' 
          }}>
            {educationKeys.map((edu, index) => (
              <div
                key={index}
                style={{
                  background: 'rgba(255, 255, 255, 0.05)',
                  borderRadius: '1rem',
                  padding: '1.5rem 1rem',
                  textAlign: 'center',
                  border: '1px solid rgba(34, 197, 94, 0.2)',
                  flex: '1 1 150px',
                  maxWidth: '200px',
                  minWidth: '140px',
                }}
              >
                <div
                  style={{
                    width: '50px',
                    height: '50px',
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 0.75rem',
                  }}
                >
                  <Icons.GraduationCap size={24} color="white" />
                </div>
                <h3 style={{ color: '#22c55e', marginBottom: '0.25rem', fontSize: '1rem', fontWeight: '600' }}>{t(`drKumar.${edu.degreeKey}`)}</h3>
                <p className="body-small" style={{ color: 'var(--text-secondary)', fontSize: '0.75rem' }}>{t(`drKumar.${edu.fieldKey}`)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Key Initiatives */}
      <section style={{ padding: '5rem 1.2rem', background: '#1f2937' }}>
        <div className="container">
          <h2 className="heading-1" style={{ textAlign: 'center', marginBottom: '3rem' }}>
            {t('drKumar.initiativesTitle')}
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem', maxWidth: '1000px', margin: '0 auto' }}>
            <div
              style={{
                background: 'linear-gradient(135deg, rgba(34, 197, 94, 0.15) 0%, rgba(34, 197, 94, 0.05) 100%)',
                borderRadius: '1rem',
                padding: '2rem',
                border: '1px solid rgba(34, 197, 94, 0.3)',
              }}
            >
              <Icons.Utensils size={40} color="#22c55e" style={{ marginBottom: '1rem' }} />
              <h3 className="heading-3" style={{ color: '#22c55e', marginBottom: '0.75rem' }}>{t('drKumar.initiative1Title')}</h3>
              <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
                {t('drKumar.initiative1Desc')}
              </p>
            </div>
            <div
              style={{
                background: 'linear-gradient(135deg, rgba(245, 158, 11, 0.15) 0%, rgba(245, 158, 11, 0.05) 100%)',
                borderRadius: '1rem',
                padding: '2rem',
                border: '1px solid rgba(245, 158, 11, 0.3)',
              }}
            >
              <Icons.Heart size={40} color="#f59e0b" style={{ marginBottom: '1rem' }} />
              <h3 className="heading-3" style={{ color: '#f59e0b', marginBottom: '0.75rem' }}>{t('drKumar.initiative2Title')}</h3>
              <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
                {t('drKumar.initiative2Desc')}
              </p>
            </div>
            <div
              style={{
                background: 'linear-gradient(135deg, rgba(236, 72, 153, 0.15) 0%, rgba(236, 72, 153, 0.05) 100%)',
                borderRadius: '1rem',
                padding: '2rem',
                border: '1px solid rgba(236, 72, 153, 0.3)',
              }}
            >
              <Icons.Youtube size={40} color="#ec4899" style={{ marginBottom: '1rem' }} />
              <h3 className="heading-3" style={{ color: '#ec4899', marginBottom: '0.75rem' }}>{t('drKumar.initiative3Title')}</h3>
              <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
                {t('drKumar.initiative3Desc')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form */}
      <ContactForm />
    </div>
  );
};

export default DrKumarProfilePage;
